<template>
  <row style="width: 100%" justify="center">
    <row justify="center">
      <column>
        <a class="w-60 mb-12" href="https://www.fitt.ai">
          <img
              class="home-page-main-logo cursor-pointer"
              src="@/assets/logos/fitt_light.png"
              alt="fitt_light"
          ></a>
      </column>
    </row>
    <div style="max-width: 480px; border-radius: 1.5em"
         class=" h-2/4 flex flex-row items-center bg-white p-8 shadow-lg text-center mx-4 mb-4 md:w-1/2">
      <row class="w-full">
        <column class="w-full flex-col">

          <column v-if="personName" class="w-full flex flex-col justify-center items-center">
            <h1 class="text-bold text-3xl text-center">{{ personName }}</h1>
            <h3 v-if="contactData?.position" class="text-blue-700 text-xl text-center">{{ contactData.position }}</h3>
          </column>

          <row
              v-for="category in categories"
              :key="category.name"
              style="border-top: solid 1px rgba(49, 130, 206)"
              class="mt-6"
          >
            <h3
                class="w-full text-center mb-6 mt-6"
            >
              {{ category.heading }}
            </h3>

            <template v-for="button in category.buttons">
              <div :key="button.value"
                   style="box-shadow: 0 4px 8px 2px rgba(136, 136, 136, 0.5);"
                   class="relative w-full h-20 mb-3 flex text-center justify-center items-center space-x-2 bg-white-100 hover:bg-gray-200 text-gray-700 font-sm py-2 px-4 rounded-lg transition duration-200"
              >
                <template v-if="button.type !== 'link'">
                  <template v-if="button.type === 'mail'">
                    <a
                        style="width: 100%;"
                        :href="'mailto:' + button.value"
                        target="_blank"
                    >
                      <Icon
                          class="absolute ml-6 left-0"
                          icon="email-outline">
                        >
                      </Icon>
                      <span v-if="button.text">{{ button.text }}</span>
                    </a>
                  </template>
                  <template v-if="button.type === 'phone'">
                    <a
                        style="width: 100%;"
                        :href="'tel:' + button.value"
                        target="_blank"
                    >
                      <Icon
                          class="absolute ml-6 left-0"
                          icon="cellphone">
                        >
                      </Icon>
                      <span v-if="button.text">{{ button.text }}</span>
                    </a>
                  </template>
                </template>
                <template v-else>
                  <a
                      style="width: 100%; height: 100%;"
                      class="flex items-center justify-center"
                      :href="button.value"
                      target="_blank"
                  >
                    <Icon
                        ref="icon"
                        v-if="button.icon"
                        class="absolute ml-6 left-0"
                        :icon="button.icon">
                    </Icon>
                    <Icon
                        v-else
                        class="absolute ml-6 left-0"
                        icon="link">
                      >
                    </Icon>
                    <span v-if="button.text">{{ button.text }}</span>
                  </a>
                </template>
              </div>
            </template>

            <!--            <button-->
            <!--                v-if="category.type === 'contact'"-->
            <!--                @click="downloadContact(category.buttons)"-->
            <!--                class="relative w-full h-20 mb-3 flex text-center justify-center items-center border-2 text-blue-700 border-blue-700 bg-white font-sm font-bold py-2 px-4 rounded-lg transition duration-200"-->
            <!--            >-->
            <!--              Download Contact-->
            <!--            </button>-->
          </row>

<!--          <row>-->
<!--            <div-->
<!--                style="box-shadow: 0 4px 8px 2px rgba(136, 136, 136, 0.5);"-->
<!--                class="relative w-full h-20 mb-3 flex text-center justify-center items-center space-x-2 bg-white-100 hover:bg-gray-200 text-gray-700 font-sm py-2 px-4 rounded-lg transition duration-200"-->
<!--            >-->
<!--              <a-->
<!--                  style="width: 100%;"-->
<!--                  href="https://www.fitt.ai"-->
<!--                  target="_blank"-->
<!--              >-->
<!--                <Icon-->
<!--                    class="absolute ml-6 left-0"-->
<!--                    icon="earth">-->
<!--                  >-->
<!--                </Icon>-->
<!--                <span>fitt Website</span>-->
<!--              </a>-->
<!--            </div>-->
<!--          </row>-->

        </column>
      </row>
    </div>
  </row>
</template>

<script>
import Icon from "@/components/display/Icon.vue";

export default {
  name: "PersonalLinkTreePage.vue",
  props: {
    contactData: {
      type: Object,
    }
  },
  components: {Icon},
  data: function () {
    return {
      personName: null,
      contactDetailsTemplate: {
        heading: "Contact Details",
        type: 'contact',
        buttons: [
          {
            text: '',
            value: '',
            icon: 'email-outline',
            type: 'mail',
          },
          {
            text: '',
            value: '',
            icon: 'cellphone',
            type: 'phone',
          }
        ]
      },
      socialLinksTemplate: {
        heading: "My Social Links",
        type: 'social',
        buttons: []
      },
      socialLinkBtnTemplate: {
        text: '',
        value: '',
        icon: '',
        type: 'link',
      },
      categories: [
        {
          heading: "Corporate Links",
          type: 'social',
          buttons: [
            {
              text: 'fitt Website',
              icon: 'earth',
              value: 'https://www.fitt.ai',
              type: 'link',
            },
            {
              text: "LinkedIn",
              value: "https://www.linkedin.com/company/fitt-talent/",
              icon: 'linkedin',
              type: 'link',
            },
            {
              text: "YouTube",
              value: "https://www.youtube.com/@fittTalent",
              icon: 'youtube',
              type: 'link',
            },
            // {
            //   text: 'Vimeo',
            //   icon: 'vimeo',
            //   value: 'https://vimeo.com/fitttalent',
            //   type: 'link',
            // },
          ]
        }
      ],
      availableIcons: [
        'play',
        'link',
        'apple',
        'google-play',
        'text-short',
        'close',
        'puzzle',
        'cloud-check',
        'fingerprint',
        'cellphone-link',
        'check-all',
        'trending-up',
        'refresh',
        'sync',
        'account-check',
        'desktop-mac-dashboard',
        'domain',
        'account-multiple',
        'message-reply-text',
        'school',
        'star-circle',
        'book-open-variant',
        'clipboard-account',
        'bank',
        'security',
        'chart-line-variant',
        'file-document',
        'clipboard-text',
        'arrow-right',
        'arrow-left',
        'code-tags',
        'account',
        'google-chrome',
        'firefox',
        'microsoft-edge',
        'menu-down',
        'menu',
        'circle-medium',
        'account-supervisor',
        'poll',
        'star-outline',
        'school-outline',
        'credit-card-outline',
        'cog-outline',
        'email-outline',
        'cellphone',
        'youtube',
        'linkedin',
        'vimeo'
      ]
    }
  },
  methods: {
    getDomainFromLink(socialLink) {

      if (socialLink) {
        try {
          const url = new URL(socialLink);
          let domain = url.hostname.replace('www.', '');

          let domainName = domain.replace(/\.[a-z]+$/, '');

          if (this.availableIcons.includes(domainName)) {
            return domainName;
          } else {
            return null;
          }
        } catch (e) {
          return null;
        }
      }

      return null;
    }
    ,
    init() {
      let contactDetails = JSON.parse(JSON.stringify(this.contactData));
      let contactDetailsTemplate = JSON.parse(JSON.stringify(this.contactDetailsTemplate));
      let socialLinksTemplate = JSON.parse(JSON.stringify(this.socialLinksTemplate));

      if (this.contactData.socials && this.contactData.socials.length > 0) {
        this.contactData.socials.forEach((social) => {
          let socialLinkBtnTemplate = JSON.parse(JSON.stringify(this.socialLinkBtnTemplate));

          socialLinkBtnTemplate.text = social.name;
          socialLinkBtnTemplate.value = social.link;
          socialLinkBtnTemplate.icon = this.getDomainFromLink(social.link);

          socialLinksTemplate.buttons.push(socialLinkBtnTemplate);
        })

        if (socialLinksTemplate.buttons.length > 0) {
          this.categories.unshift(socialLinksTemplate);
        }
      }

      if (contactDetails.fullName) {
        contactDetailsTemplate.heading = 'Contact Details';
        this.personName = contactDetails.fullName;
      }

      contactDetailsTemplate.buttons.forEach((button) => {
        if (button.type === "phone") {
          button.text = contactDetails.cellphone;
          button.value = contactDetails.cellphone;
        }

        if (button.type === "mail") {
          button.text = contactDetails.email;
          button.value = contactDetails.email;
        }
      });

      if (contactDetails.additional_cellphone) {
        contactDetailsTemplate.buttons.push(
            {
              text: contactDetails.additional_cellphone,
              value: contactDetails.additional_cellphone,
              icon: 'cellphone',
              type: 'phone',
            }
        )
      }

      if (!contactDetails.cellphone || contactDetails.cellphone.trim() === '') {
        contactDetailsTemplate.buttons.pop()
      }

      this.categories.unshift(contactDetailsTemplate);
    }
    ,
    downloadContact() {
      const contact = this.contactData;

      const vCard = `BEGIN:VCARD
                     VERSION:3.0
                     FN:${contact.fullName || ''}
                     TEL;TYPE=CELL:${contact.cellphone || ''}
                     EMAIL:${contact.email || ''}
                     END:VCARD`;

      const blob = new Blob([vCard], {type: 'text/vcard'});

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `${contact.fullName || 'contact'}.vcf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    ,
  },
  created() {
    this.init();
  }
}
</script>

<style scoped>

</style>